/**
 * Word-by-word scroll reveal. Port of src/components/TypeIn.tsx.
 *
 * Marks up any element carrying data-cs-typein: its text is split into words,
 * each wrapped in a span that animates with the hero-line-x keyframe on a
 * stagger. Whitespace is preserved as its own span so wrapping is unchanged,
 * and the original string is kept on aria-label with the pieces hidden, so
 * screen readers still read one sentence.
 *
 *   data-cs-typein        mark the element
 *   data-step="60"        per-word stagger in ms (React's default)
 *   data-delay="0"        delay before the first word
 *
 * Honours prefers-reduced-motion by leaving the text completely alone — same
 * as the React component, which returns early before splitting.
 */
(function () {
  const els = document.querySelectorAll('[data-cs-typein]');
  if (!els.length) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const prepare = (el) => {
    const text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return false;
    const step = parseInt(el.dataset.step, 10) || 60;
    const delay = parseInt(el.dataset.delay, 10) || 0;

    el.setAttribute('aria-label', text);
    // Keep whitespace tokens so words wrap exactly as they did before.
    const parts = text.split(/(\s+)/);
    let unit = 0;
    el.innerHTML = parts
      .map((part) => {
        if (/^\s+$/.test(part)) return '<span>' + part + '</span>';
        const ms = delay + unit * step;
        unit++;
        return (
          '<span aria-hidden="true" class="inline-block whitespace-nowrap opacity-0" ' +
          'data-cs-typein-word style="animation-delay:' + ms + 'ms">' +
          part.replace(/&/g, '&amp;').replace(/</g, '&lt;') +
          '</span>'
        );
      })
      .join('');
    return true;
  };

  const run = (el) => {
    el.querySelectorAll('[data-cs-typein-word]').forEach((w) => {
      w.classList.remove('opacity-0');
      w.classList.add('animate-hero-line-x');
    });
  };

  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              run(e.target);
              io.unobserve(e.target);
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        )
      : null;

  els.forEach((el) => {
    if (!prepare(el)) return;
    if (io) io.observe(el);
    else run(el);
  });
})();
